import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "Store material",
    paragraphs: [`Rights in ${STORE.brand}'s original site writing, product photography, artwork, visual treatment, brand mark and code are reserved by their respective owner. The appearance of product material does not grant a licence beyond ordinary browsing and purchasing.`],
  },
  {
    title: "Personal use",
    paragraphs: ["A visitor may view the catalogue and keep a reasonable copy of order and policy information for personal records. Removing rights notices, reproducing catalogue content for resale, systematic image extraction, misleading alteration or presenting the shop as an endorser requires prior authority from the relevant rights holder."],
  },
  {
    title: "Customer submissions",
    paragraphs: ["A customer keeps ownership of original photographs and writing supplied privately for a support case. The limited permission to use that material for investigation is described in Support Evidence & Customer Content and does not authorise advertising use."],
    links: [["Support Evidence & Customer Content", "/customer-content"]],
  },
  {
    title: "Rights notice requirements",
    paragraphs: ["A rights notice needs enough precision to locate the work and challenged page or asset. It should explain the sender's ownership basis, requested action and reply details; a representative must also state their authority. Supporting evidence offered in good faith helps route the matter separately from an ordinary product complaint."],
  },
  {
    title: "Review and response",
    paragraphs: ["The identified material and ownership basis are examined before restriction, correction or removal. Additional detail may be requested where the location or authority cannot be determined. A response explains the action taken or the information still needed, subject to rights and obligations that apply to the material."],
  },
  {
    title: "No false endorsement",
    paragraphs: ["Store names, product pages or imagery must not be used to suggest sponsorship, partnership or origin that does not exist. Likewise, a third party's name appearing in legitimate evidence remains that party's property and is not claimed by this policy."],
  },
];

export default function IntellectualProperty() {
  return <PolicyPage title="Intellectual Property Policy" intro="Permitted catalogue use, ownership of support material and the route for a rights notice." sections={sections} related={[["Terms of Use", "/terms"], ["Complaints & Policy Updates", "/complaints"]]} />;
}
